import React, { useEffect, useState } from "react";
import axios from "axios";
import back from "../Assets/Back.svg";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
const PrivacyMobile = ({ setSettings }) => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    loadDetails();
  }, []);
  const loadDetails = async () => {
    try {
      const data = await axios.get(`https://storage.googleapis.com/goviralcampaign/privacyPolicyMobile.json`);
      setData(data.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const [searchParams, setSearchParams] = useSearchParams();
  const loadingFromApp = searchParams.get("from")?.startsWith("mobile");

  return (
    <div className="widthController ">
      <div className="flex flex-col text-[17px] bg-black px-[16px] pt-[30px]">
        {/* {!loadingFromApp && (
          <img
            src={back}
            alt=""
            onClick={() => {
              navigate(-1);
            }}
            className=" h-[50px] w-[13px] "
          />
        )} */}
        {data &&
          data.privacyPolicy &&
          data.privacyPolicy.map((obj) => {
            return (
              <>
                {/* <span className='pb-[10px] text-{}' >{obj.heading}</span> */}
                {obj.heading && (
                  <span
                    className={`mb-[20px] mt-[30px] text-[${obj.color}] text-[${obj.size}] ${obj?.className}`}
                  >
                    {obj.heading}
                  </span>
                )}
                {obj.paragraph && (
                  <span
                    className={`mb-[30px] text-[${obj.color}] text-[${obj.size}] ${obj?.className}`}
                  >
                    {obj.paragraph}
                  </span>
                )}
              </>
            );
          })}
      </div>
    </div>
  );
};

export default PrivacyMobile;
